import { useContext } from 'react';
import Alert from 'react-bootstrap/Alert';
import Collapse from 'react-bootstrap/Collapse';
import { FlashContext } from '../../contexts/FlashProvider';

export default function FlashMessage() {
  const { flashMessage, visible, hideFlash } = useContext(FlashContext);

  return (
    <Collapse in={visible}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999, // Ensure it appears above other content
          padding: '75px',
          marginTop: '10px', // Margin for spacing from the top
        }}
      >
        <Alert
          variant={flashMessage.type || 'info'}
          dismissible
          onClose={hideFlash}
          style={{
            padding: '15px',
            paddingRight: '50px',
            marginBottom: '0', // Remove bottom margin
          }}
        >
          {flashMessage.message}
        </Alert>
      </div>
    </Collapse>
  );
}
